import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadResourcesQueryVariables = {
  rootId: Types.Scalars['String'],
  category?: Types.Maybe<Types.Scalars['String']>,
  type?: Types.Maybe<Types.Scalars['String']>,
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadResourcesQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | '_deleted' | 'type' | 'category' | 'title' | 'inactive' | 'rootId' | 'abbr' | 'annotation' | 'notification' | 'unit' | 'costPerUnit' | 'color' | 'licensePlate' | 'chassisNumber' | 'tuevSweden' | 'tuevUntil' | 'origin' | 'destination' | 'location' | 'countryCode' | 'place' | 'address' | 'land' | 'phone' | 'fax' | 'contact' | 'email' | 'emailHRG' | 'parentId' | 'external'>
    & { usageTimespans: Types.Maybe<Array<(
      { __typename?: 'UsageTimeSpan' }
      & Pick<Types.UsageTimeSpan, 'dateFrom' | 'dateTo'>
    )>>, parent: Types.Maybe<(
      { __typename?: 'Resource' }
      & Pick<Types.Resource, '_id' | 'title'>
    )> }
  )> }
);

export type LiftingPlatformsQueryVariables = {
  rootId: Types.Scalars['String']
};


export type LiftingPlatformsQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'type' | 'parentId'>
  )> }
);

export type ReadAllResourcesQueryVariables = {};


export type ReadAllResourcesQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title'>
  )> }
);

export type CreateResourceMutationVariables = {
  input?: Types.Maybe<Types.ResourceInsertType>
};


export type CreateResourceMutation = (
  { __typename?: 'Mutation' }
  & { createResource: (
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | '_deleted' | 'type' | 'category' | 'title' | 'inactive' | 'rootId' | 'abbr' | 'annotation' | 'unit' | 'costPerUnit' | 'color' | 'licensePlate' | 'chassisNumber' | 'tuevSweden' | 'tuevUntil' | 'origin' | 'destination' | 'location' | 'countryCode' | 'place' | 'address' | 'land' | 'phone' | 'fax' | 'contact' | 'email' | 'emailHRG' | 'parentId' | 'external'>
    & { usageTimespans: Types.Maybe<Array<(
      { __typename?: 'UsageTimeSpan' }
      & Pick<Types.UsageTimeSpan, 'dateFrom' | 'dateTo'>
    )>>, parent: Types.Maybe<(
      { __typename?: 'Resource' }
      & Pick<Types.Resource, 'title'>
    )> }
  ) }
);

export type UpdateResourceMutationVariables = {
  _id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.ResourceSetType>
};


export type UpdateResourceMutation = (
  { __typename?: 'Mutation' }
  & { updateResource: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'parentId' | 'type' | 'category' | 'title' | 'inactive' | 'rootId' | 'abbr' | 'annotation' | 'unit' | 'costPerUnit' | 'color' | 'licensePlate' | 'chassisNumber' | 'tuevSweden' | 'tuevUntil' | 'origin' | 'destination' | 'location' | 'countryCode' | 'place' | 'address' | 'land' | 'phone' | 'fax' | 'contact' | 'email' | 'emailHRG' | 'external'>
    & { usageTimespans: Types.Maybe<Array<(
      { __typename?: 'UsageTimeSpan' }
      & Pick<Types.UsageTimeSpan, 'dateFrom' | 'dateTo'>
    )>>, parent: Types.Maybe<(
      { __typename?: 'Resource' }
      & Pick<Types.Resource, '_id' | 'title'>
    )> }
  )> }
);

export type DeleteResourceMutationVariables = {
  ids?: Types.Maybe<Array<Types.Scalars['ID']>>
};


export type DeleteResourceMutation = (
  { __typename?: 'Mutation' }
  & { deleteResource: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_deleted'>
  )> }
);

export const ReadResourcesDocument = gql`
    query ReadResources($rootId: String!, $category: String, $type: String, $search: String) {
  resources(filter: {OR: [{title: {REGEX: $search, OPTIONS: "i"}}, {annotation: {REGEX: $search, OPTIONS: "i"}}], rootId: {EQ: $rootId}, category: {EQ: $category}, type: {EQ: $type}}) {
    _id
    _deleted
    type
    category
    title
    inactive
    rootId
    abbr
    annotation
    notification
    unit
    costPerUnit
    color
    licensePlate
    chassisNumber
    tuevSweden
    tuevUntil
    origin
    destination
    location
    countryCode
    place
    address
    land
    phone
    fax
    contact
    email
    emailHRG
    parentId
    external
    usageTimespans {
      dateFrom
      dateTo
    }
    parent {
      _id
      title
    }
  }
}
    `;

    export function useReadResourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadResourcesQuery, ReadResourcesQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadResourcesQuery, ReadResourcesQueryVariables>(ReadResourcesDocument, baseOptions);
    };
      export function useReadResourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadResourcesQuery, ReadResourcesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadResourcesQuery, ReadResourcesQueryVariables>(ReadResourcesDocument, baseOptions);
      };
      
export type ReadResourcesQueryHookResult = ReturnType<typeof useReadResourcesQuery>;
export type ReadResourcesQueryResult = ApolloReactCommon.QueryResult<ReadResourcesQuery, ReadResourcesQueryVariables>;
export const LiftingPlatformsDocument = gql`
    query liftingPlatforms($rootId: String!) {
  resources(filter: {type: {EQ: "liftingPlatform"}, rootId: {EQ: $rootId}}) {
    _id
    type
    parentId
  }
}
    `;

    export function useLiftingPlatformsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LiftingPlatformsQuery, LiftingPlatformsQueryVariables>) {
      return ApolloReactHooks.useQuery<LiftingPlatformsQuery, LiftingPlatformsQueryVariables>(LiftingPlatformsDocument, baseOptions);
    };
      export function useLiftingPlatformsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LiftingPlatformsQuery, LiftingPlatformsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<LiftingPlatformsQuery, LiftingPlatformsQueryVariables>(LiftingPlatformsDocument, baseOptions);
      };
      
export type LiftingPlatformsQueryHookResult = ReturnType<typeof useLiftingPlatformsQuery>;
export type LiftingPlatformsQueryResult = ApolloReactCommon.QueryResult<LiftingPlatformsQuery, LiftingPlatformsQueryVariables>;
export const ReadAllResourcesDocument = gql`
    query ReadAllResources {
  resources(filter: {AND: [{category: {NEQ: "lodging"}}, {type: {NEQ: "workstation"}}]}) {
    _id
    title
  }
}
    `;

    export function useReadAllResourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadAllResourcesQuery, ReadAllResourcesQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadAllResourcesQuery, ReadAllResourcesQueryVariables>(ReadAllResourcesDocument, baseOptions);
    };
      export function useReadAllResourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadAllResourcesQuery, ReadAllResourcesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadAllResourcesQuery, ReadAllResourcesQueryVariables>(ReadAllResourcesDocument, baseOptions);
      };
      
export type ReadAllResourcesQueryHookResult = ReturnType<typeof useReadAllResourcesQuery>;
export type ReadAllResourcesQueryResult = ApolloReactCommon.QueryResult<ReadAllResourcesQuery, ReadAllResourcesQueryVariables>;
export const CreateResourceDocument = gql`
    mutation CreateResource($input: ResourceInsertType) {
  createResource(input: $input) {
    _id
    _deleted
    type
    category
    title
    inactive
    rootId
    abbr
    annotation
    unit
    costPerUnit
    color
    licensePlate
    chassisNumber
    tuevSweden
    tuevUntil
    origin
    destination
    location
    countryCode
    place
    address
    land
    phone
    fax
    contact
    email
    emailHRG
    parentId
    external
    usageTimespans {
      dateFrom
      dateTo
    }
    parent {
      title
    }
  }
}
    `;
export type CreateResourceMutationFn = ApolloReactCommon.MutationFunction<CreateResourceMutation, CreateResourceMutationVariables>;

    export function useCreateResourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateResourceMutation, CreateResourceMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateResourceMutation, CreateResourceMutationVariables>(CreateResourceDocument, baseOptions);
    };
export type CreateResourceMutationHookResult = ReturnType<typeof useCreateResourceMutation>;
export type CreateResourceMutationResult = ApolloReactCommon.MutationResult<CreateResourceMutation>;
export type CreateResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateResourceMutation, CreateResourceMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($_id: ID, $update: ResourceSetType) {
  updateResource(filter: {_id: {EQ: $_id}}, update: {set: $update}) {
    _id
    parentId
    type
    category
    title
    inactive
    rootId
    abbr
    annotation
    unit
    costPerUnit
    color
    licensePlate
    chassisNumber
    tuevSweden
    tuevUntil
    origin
    destination
    location
    countryCode
    place
    address
    land
    phone
    fax
    contact
    email
    emailHRG
    external
    usageTimespans {
      dateFrom
      dateTo
    }
    parentId
    parent {
      _id
      title
    }
  }
}
    `;
export type UpdateResourceMutationFn = ApolloReactCommon.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

    export function useUpdateResourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, baseOptions);
    };
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = ApolloReactCommon.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation DeleteResource($ids: [ID!]) {
  deleteResource(filter: {_id: {IN: $ids}}) {
    _deleted
  }
}
    `;
export type DeleteResourceMutationFn = ApolloReactCommon.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

    export function useDeleteResourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, baseOptions);
    };
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = ApolloReactCommon.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;